import { useCallback, useMemo } from 'react';

import {
  createSpec,
  specTypes,
  useFetch,
  useDataRefId,
  useRefetch,
} from '@bingads-webui-react/overreact';

import { environmentLookupFn } from '../../../environment/index';
import { fetchRequestContract, fetchResponseContract } from '../spec/fetch';

const fetchSpec = createSpec(
  fetchRequestContract, fetchResponseContract,
  specTypes.FETCH, null, environmentLookupFn
);
const refetchSpec = createSpec(
  fetchRequestContract, fetchResponseContract,
  specTypes.REFETCH, null, environmentLookupFn
);

const DEFAULT_CONFIG = {};

export function useCampaignIdsWithESCBudgetLandscape(dataLocator, config = DEFAULT_CONFIG) {
  const dataRefId = useDataRefId(null, environmentLookupFn);
  const defaultConfig = useMemo(() => ({
    fetch: config.fetch || {},
    refetch: config.refetch || {},
  }), [config]);
  const { fetch: fetchConfig, refetch: refetchConfig } = defaultConfig;

  const fetch = useFetch(dataRefId, fetchSpec, dataLocator, fetchConfig);
  const refetchFn = useRefetch(dataRefId, refetchSpec, refetchConfig);

  const read = useCallback((param = {}, requestConfig, ...rest) => {
    refetchFn({
      variables: { ...dataLocator, ...param.variables },
    }, requestConfig, ...rest);
  }, [dataLocator, refetchFn]);

  const [data, error] = fetch;

  return [{
    data,
    error,
  }, {
    read,
  }];
}
